import React from 'react';
import { Controller, Control } from 'react-hook-form';
import { FormControl, TextField } from '@material-ui/core';
import { SearchableSelectField } from '../../CreateTeamDrawer/SearchableSelectField';
import { CreateRoleFormValues } from '../types';
import { FormFields } from '../styles';
import type { SelectOption } from '../../CreateTeamDrawer/types';

interface RoleDetailsStepProps {
  control: Control<CreateRoleFormValues>;
  teamOptions: SelectOption[];
  isLoadingTeams: boolean;
}

export function RoleDetailsStep({
  control,
  teamOptions,
  isLoadingTeams,
}: RoleDetailsStepProps) {
  return (
    <FormControl component="fieldset" style={{ width: '100%' }}>
      <FormFields>
        <Controller
          name="name"
          control={control}
          render={({ field, fieldState: { error } }) => (
            <TextField
              {...field}
              variant="outlined"
              placeholder="Name"
              required
              label="Name"
              fullWidth
              InputLabelProps={{ shrink: true }}
              error={Boolean(error)}
              helperText={error?.message}
            />
          )}
        />
        <Controller
          name="description"
          control={control}
          render={({ field, fieldState: { error } }) => (
            <TextField
              {...field}
              variant="outlined"
              placeholder="Description"
              label="Description"
              fullWidth
              multiline
              rows={2}
              InputLabelProps={{ shrink: true }}
              error={Boolean(error)}
              helperText={error?.message}
            />
          )}
        />
        <Controller
          name="teamId"
          control={control}
          render={({ field, fieldState: { error } }) => (
            <SearchableSelectField
              label="Team"
              value={field.value}
              options={teamOptions}
              onChange={field.onChange}
              loading={isLoadingTeams}
              disabled={isLoadingTeams}
              error={Boolean(error)}
              helperText={error?.message}
            />
          )}
        />
      </FormFields>
    </FormControl>
  );
}
